export default "__VITE_ASSET__tT8rIJHY__"